module.exports = "<div class=\"dialog\" ng-if=\"$ctrl.isOpen()\">\n    <photo-lightbox></photo-lightbox>\n</div>\n";